import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'SearchPage',
    component: () => import('@/views/Search.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/bind',
    name: 'CustomerBind',
    component: () => import('@/views/CustomerBind.vue')
  },
  {
    path: '/logistics',
    name: 'LogisticDetail',
    component: () => import('@/views/LogisticDetail.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router 